
import catalog from '@/components/tools/catalog'

export default {
  props: {
    chipClass: {
      type: String,
      default: ''
    },
    context: {
      type: Object,
      default: () => undefined
    },
    status: {
      type: String,
      default: undefined
    },
    small: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    renegStatus: {
      type: String,
      default: undefined
    },
    orderStatus: {
      type: String,
      default: undefined
    }
  },

  computed: {
    holdingHighestBid () {
      return this.context?.holdingHighestBid
    },

    label () {
      if (this.orderStatus && ['canceled',
        'pending_payment_by_seller',
        'paid_by_seller',
        'canceled_payment_by_seller'].includes(this.orderStatus)) {
        return
      }

      if (this.context?.hasFailedLateOfferOnProduct === true) {
        return this.$t('customer.context.late_offer_declined')
      }

      if (this.status === 'acpt_late_offer') {
        return
      }

      if (this.holdingHighestBid && ['recd_late_offer'].includes(this.status)) {
        return this.$t('customer.context.late_offer_pending')
      }

      if (this.context?.hasFailedLateOfferOnProduct === true) {
        return this.$t('customer.context.late_offer_declined')
      }

      if (this.holdingHighestBid && ['failed'].includes(this.status)) {
        return this.$t('customer.context.offer_declined')
      }

      return catalog.getCustomerContextLabel(this.holdingHighestBid, this)
    },
    color () {
      if (this.context?.hasFailedLateOfferOnProduct === true) {
        return 'var(--v-error-base)'
      }

      if (this.holdingHighestBid && ['failed', 'acpt_late_offer'].includes(this.status)) {
        return 'var(--v-error-base)'
      }

      if (this.holdingHighestBid === true) {
        return 'success'
      } else if (this.holdingHighestBid === false) {
        return 'var(--v-error-base)'
      }
      return undefined
    }
  }

}
